// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__RQcny","resendInfoText":"OnGoingPaymentBox_resendInfoText__33Bwa"};